module.exports = __webpack_public_path__ + "static/media/0.41c2b420.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/body/0.png
// module id = 132
// module chunks = 0